import { IconType, SvgIcon } from './SvgIcon';

export const QuestionMarkIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M9.99996 18.8332C14.6023 18.8332 18.3333 15.1022 18.3333 10.4998C18.3333 5.89746 14.6023 2.1665 9.99996 2.1665C5.39759 2.1665 1.66663 5.89746 1.66663 10.4998C1.66663 15.1022 5.39759 18.8332 9.99996 18.8332Z"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.57495 7.99999C7.77087 7.44304 8.15758 6.97341 8.66658 6.67426C9.17558 6.37512 9.77403 6.26577 10.3559 6.36558C10.9378 6.46539 11.4656 6.76792 11.8458 7.21959C12.2261 7.67126 12.4342 8.24292 12.4333 8.83332C12.4333 10.5 9.93328 11.3333 9.93328 11.3333"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.6665H10.0083"
      stroke="currentColor"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

QuestionMarkIcon.displayName = 'QuestionMarkIcon';
